export const utils = {
    productperPage: 75,
    referFrient: false, // Main referral system flag (for QuickLinks, etc.)
    referralDashboardSidebar: true, // Show "Referral Dashboard" link in sidebar menu (true = show, false = hide)
    referralDashboardPrivacy: true, // Show "Referral Bonus" section with Dashboard link in Privacy Policy (true = show, false = hide)
    referAFriendSidebar: true, // Show "Refer a Friend" in sidebar menu (true = show, false = hide)
    referAFriendPrivacy: true, // Show "Refer a Friend" section in Privacy Policy (true = show, false = hide)
    referralRewardAmount: 50, // Referral reward amount in rupees (shown as "Earn up to ₹X")
    priceSort: false,
    comingSoon: false // Set to true to show "Coming Soon" screen instead of app
}

const SUPPORT_CONTACT = {
    phone: "+919630041385", // Full phone number with country code
    phoneNumber: "9630041385", // Phone number without country code (for wa.me links)
    whatsappMessage: "Hi, I need help with my order/refund/cashback. Can you assist me?", // Default WhatsApp message
};

export { SUPPORT_CONTACT };

export const defaultImageUrl = "https://myawse-commerceapp.s3.ap-south-1.amazonaws.com/Serverimg/Preview_optimized.jpg"